module.exports = __webpack_public_path__ + "img/workers.d4e4993f.png";